import { DrawerControls, DrawerState, useDrawer } from 'kineticUtils/hooks';
import { PropsWithChildren, createContext, useContext } from 'react';

type AppDrawerContextValue = {
  appDrawerState: DrawerState;
  appDrawerControls: DrawerControls;
};
const AppDrawerContext = createContext<AppDrawerContextValue>({
  appDrawerControls: {
    closeDrawer: () => {},
    openDrawer: () => {},
    toggleDrawer: () => {},
    lockDrawer: () => {},
    unlockDrawer: () => {},
  },
  appDrawerState: {
    locked: false,
    open: false,
  },
});

export const useAppDrawerContext = () => {
  const context = useContext(AppDrawerContext);
  if (!context) {
    throw new Error('Cannot find AppDrawerContext');
  }
  return context;
};

type AppDrawerContextProviderProps = PropsWithChildren<{}>;
export const AppDrawerContextProvider = ({ children }: AppDrawerContextProviderProps) => {
  const [appDrawerState, appDrawerControls] = useDrawer();

  return (
    <AppDrawerContext.Provider value={{ appDrawerState, appDrawerControls }}>
      {children}
    </AppDrawerContext.Provider>
  );
};
